/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kuendigungdurch1Inputs */

const de__field_kuendigungdurch1 = /** @type {(inputs: _Field_Kuendigungdurch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigung durch`)
};

/**

* @param {_Field_Kuendigungdurch1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kuendigungdurch1 = /** @type {((inputs?: _Field_Kuendigungdurch1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kuendigungdurch1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kuendigungdurch1(inputs)
});
export { _field_kuendigungdurch1 as "_field_kuendigungDurch" }